import { c as _c } from "react/compiler-runtime";
import { default as React, useEffect, useMemo, useState } from 'react';
import { type AmplitudeInstance, getAmplitudeClient } from './core/amplitude';
import { AmplitudeContext } from './core/amplitude-context';
import type { AmplitudeConfig } from './core/config';
export type TrackingStrategy = 'dnt-local-storage' | 'always';
interface Props {
  /** Nothing is initialised while `undefined` (no api key, opted out, or not known yet); it may arrive after mount. */
  config?: AmplitudeConfig;
  /** `dnt-local-storage` (default) only tracks after the user consented; `always` for B2B. */
  trackingStrategy?: TrackingStrategy;
}
function isTrackingEnabled(strategy: TrackingStrategy) {
  if (strategy === 'always') {
    return true;
  }
  return localStorage.getItem('dnt') === '0';
}

/** Mount it once, at the root of the app: the client is one per api key and the first configuration wins. */
const AmplitudeProvider = t0 => {
  const $ = _c(13);
  const {
    config,
    children,
    trackingStrategy: t1
  } = t0;
  const trackingStrategy = t1 === undefined ? "dnt-local-storage" : t1;
  const [instance, setInstance] = useState(null);
  const apiKey = config?.apiKey;
  let t2;
  if ($[0] !== apiKey || $[1] !== config || $[2] !== instance || $[3] !== trackingStrategy) {
    t2 = () => {
      if (!config || !apiKey || instance) {
        return;
      }
      if (isTrackingEnabled(trackingStrategy)) {
        setInstance(getAmplitudeClient(config));
      }
    };
    $[0] = apiKey;
    $[1] = config;
    $[2] = instance;
    $[3] = trackingStrategy;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== apiKey) {
    t3 = [apiKey];
    $[5] = apiKey;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  const t4 = instance?.client ?? null;
  let t5;
  if ($[7] !== instance || $[8] !== t4) {
    t5 = {
      amplitude: t4,
      instance
    };
    $[7] = instance;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const value = t5;
  let t6;
  if ($[10] !== children || $[11] !== value) {
    t6 = <AmplitudeContext.Provider value={value}>{children}</AmplitudeContext.Provider>;
    $[10] = children;
    $[11] = value;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default AmplitudeProvider;